<script setup lang="ts">
import { OnClickOutside } from "@vueuse/components";
import { useModal } from "shared/composables";

const { isModalOpened, openModal, closeModal } = useModal();
</script>

<template>
	<div>
		<AppButtonIcon v-show="isModalOpened" name="ic:round-close" @click="closeModal" />
		<AppButtonIcon v-show="!isModalOpened" name="ic:round-menu" @click="openModal" />
		<teleport to="body">
			<div v-if="isModalOpened" class="fixed top-0 left-0 z-10 w-screen h-screen flex justify-end bg-black/40 duration-125"></div>
			<OnClickOutside @trigger="closeModal">
				<Transition name="slide">
					<div v-if="isModalOpened" class="fixed left-0 top-[82px] w-full border-t border-gray bg-white px-4 pt-5 pb-6 z-20 sm:px-6">
						<HomeSearch @update:search="closeModal" />
						<LayoutHeaderNav class="mt-5" @click:link="closeModal" />
					</div>
				</Transition>
			</OnClickOutside>
		</teleport>
	</div>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 300ms ease-in-out;
}

.slide-enter-from,
.slide-leave-to {
  top: -264px;
}
</style>
